import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getShowIdentityUiTwoStepVerification } from '../selectors';

const TwoStepVerificationWrapper = ({
  IdentityUiTwoStepVerification,
  OneIdentityTwoStepVerification,
  showIdentityUiTwoStepVerification,
  loadStatus,
  location,
  route,
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  // Check for market flag AND password handling
  return showIdentityUiTwoStepVerification
    ? <IdentityUiTwoStepVerification location={location} route={route} />
    : <OneIdentityTwoStepVerification location={location} route={route} />;
};

TwoStepVerificationWrapper.propTypes = {
  IdentityUiTwoStepVerification: PropTypes.func.isRequired,
  OneIdentityTwoStepVerification: PropTypes.node.isRequired,
  showIdentityUiTwoStepVerification: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = TwoStepVerificationWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiTwoStepVerification: () => dispatch(queryModuleWithData('identity-ui-two-step-verification')),
  OneIdentityTwoStepVerification: () => dispatch(queryModuleWithData('one-identity-two-step-verification')),
  showIdentityUiTwoStepVerification: () => ({ status: 'complete', data: getShowIdentityUiTwoStepVerification(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(TwoStepVerificationWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(TwoStepVerificationWrapper);
